import { render, staticRenderFns } from "./AdminPortal.vue?vue&type=template&id=6123ce5e&"
import script from "./AdminPortal.vue?vue&type=script&lang=js&"
export * from "./AdminPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports